import {useMMKVBoolean} from 'react-native-mmkv';
import {isPremiumKey} from '../storage';

export function useIsPremium() {
  const [isPremium, setIsPremium] = useMMKVBoolean(isPremiumKey);
  return {isPremium, setIsPremium};
}
